import * as React from "react";
import { merge, $ } from "glamor";
import theme from "styles/theme";

interface IProps {
    breadcrumbs: Array<{ displayName: string; path?: string }>;
    breadcrumbsRef: React.Ref<HTMLDivElement>;
}

export const Breadcrumbs: React.FunctionComponent<IProps> = ({ breadcrumbs, breadcrumbsRef }) => {
    const styles = React.useMemo(() => {
        return merge(
            {
                padding: "0 20px",
            },
            $(" .breadcrumb a", {
                color: theme.palette.darkGrey,
                textDecoration: "underline",
                paddingRight: "3px",
            }),
            $(" .breadcrumb div", {
                color: theme.palette.textColor,
                fontWeight: "bold",
            }),
            $(" .breadcrumb span", {
                color: theme.palette.darkGrey,
            })
        );
    }, []);
    const lastEntry = breadcrumbs.length - 1;

    return (
        <div className="breadcrumbs" {...styles} ref={breadcrumbsRef}>
            {breadcrumbs.map((link, index) => {
                let component;
                if (link.path && index !== lastEntry) {
                    component = <a href={link.path}>{link.displayName}</a>;
                } else {
                    component = <div>{link.displayName}</div>;
                }
                return (
                    <div key={link.displayName} className="breadcrumb">
                        {component}
                        {lastEntry !== index && <span>/</span>}
                    </div>
                );
            })}
        </div>
    );
};
